import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import SoundUtils from "@/utils/sound-utils";
import {GiftCategory, GiftDto} from "@/store/gift/types";
import GiftStore from "@/store/gift";
import {VerticalLongPanel} from "@/scenes.ui/vertical-long-panel";
import {GiftAndPrice} from "@/scenes.ui/gift-and-price";
import {InputTextPanel} from "@/scenes.ui/input-text-panel";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import PlayerStore from "@/store/player";
import {GiftUtils} from "@/utils/gift-utils";
import {Tr} from "@/i18n/i18n";
import BaseSound = Phaser.Sound.BaseSound;
import Container = Phaser.GameObjects.Container;
import Image = Phaser.GameObjects.Image;
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import TaskUtils from "@/utils/task-utils";

export class GiftsPanel extends VerticalLongPanel {

    private selectSound!: BaseSound | undefined;

    private mainContainer!: Container;

    private giftTabs: GiftTab[] = [];

    private callback!: (giftId: string, message: string) => unknown

    constructor(scene: Phaser.Scene, canvas: HTMLCanvasElement, callback: (giftId: string, message: string) => unknown) {
        super(scene, canvas, Tr('gft.pck'));

        this.selectSound = SoundUtils.addSound(scene, Keys.SOUND_SELECT);
        this.callback = callback;

        this.resetActiveTab();

        let xx = -86;
        let yy = -100;

        let giftCategories = [GiftCategory.TASTY, GiftCategory.PETS, GiftCategory.VIP];
        giftCategories.push(GiftCategory.SUMMER);
        // if(TaskUtils.fromBirthdayHatToEasterTime()){
        //     giftCategories.push(GiftCategory.EASTER);
        // } else {
        //     giftCategories.push(GiftCategory.WOMAN);
        // }

        for (let gc of giftCategories) {
            let giftTab = new GiftTab(scene, canvas, xx, yy, false, gc,
                (giftCategory: GiftCategory) => {
                    SoundUtils.play(this.selectSound);
                    this.resetActiveTab();
                    this.giftTabs.forEach(st => st.setSelected(false));
                    giftTab.setSelected(true);
                    this.populateTab(giftCategory);
                });
            xx += 56;
            this.giftTabs.push(giftTab);
        }

        this.giftTabs[3].select();

        let separator = SpriteUtils.addSprite(this.scene!, 0, -175, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR_LARGE);
        separator.displayWidth = 440 * CU.S;

        this.add([separator, ...this.giftTabs]);

    }

    private populateTab(giftCategory: GiftCategory) {
        let self = this;
        let conts: Container[] = [];
        GiftStore.getAvailableGifts(giftCategory).then((gifts: GiftDto[]) => {
            let group = this.scene.add.group();
            for (let g of gifts) {
                const gift = new GiftAndPrice(self.scene, g, () => {
                    if (g.price > PlayerStore.getPlayer().mithril) {
                        new FeedbackPanel(self.scene, Tr('ne.hvataet.izumrudov'), undefined, true).show();
                    } else {
                        let textPanel: InputTextPanel = new InputTextPanel(self.scene, self.canvas,  Tr('desire'), Tr('ent.desire'),
                        Tr('ent.desire.2'), Tr('pres'), "",(message: string) => {
                            textPanel.closePanel();
                            self.close();
                            self.callback(g.id, message);
                        });
                        textPanel.openAnimated();
                    }
                });
                group.add(gift)
                conts.push(gift);
            }
            Phaser.Actions.GridAlign(group.getChildren(), {
                width: 4,
                height: 8,
                cellWidth: 110 * CU.S,
                cellHeight: 145 * CU.S,
                x: -110 * CU.S - 110 * CU.S / 2,
                y: -35 * CU.S - 145 * CU.S / 2,
            });
            this.mainContainer.add([...conts]);
        });
    }

    private resetActiveTab() {
        if (this.mainContainer) {
            this.mainContainer.setVisible(false);
            this.mainContainer.destroy();
        }
        this.mainContainer = new Container(this.scene);
        this.add(this.mainContainer);
    }

}

export class GiftTab extends Phaser.GameObjects.Container {

    private callback!: (giftCategory: GiftCategory) => void;

    private giftCategory!: GiftCategory;
    private tabImage!: Image;

    constructor(scene: Phaser.Scene, canvas: HTMLCanvasElement, x: number, y: number, selected: boolean,
                giftCategory: GiftCategory, callback: (giftCategory: GiftCategory) => void) {
        super(scene, x * CU.S, y * CU.S);

        this.callback = callback;
        this.giftCategory = giftCategory;

        this.tabImage = SpriteUtils.addImage(this.scene, x, y, Keys.ATLAS_SHOP_UI, selected ? Keys.UI_SHOP_TAB_ACTIVE : Keys.UI_SHOP_TAB_INACTIVE, 112/280, 1)
            .setInteractive();

        //SpriteUtils.setDispSize(this.tabImage, 112 * CU.S, 50 * CU.S);
        this.tabImage.on('pointerup', () => {
            if (this.callback != null) {
                this.callback(giftCategory);
            }
        });

        let tabText = TextUtils.addTextByFamily(this.scene, GiftUtils.getName(giftCategory), this.tabImage.x / CU.S, this.tabImage.y / CU.S, '#ffffff', 13,
            'normal', 420, Fonts.ARIAL_MT);

        this.add([this.tabImage, tabText]);

    }


    public select() {
        if (this.callback != null) {
            this.callback(this.giftCategory);
        }
    }

    public setSelected(selected: boolean): void {
        SpriteUtils.setSprite(this.scene, this.tabImage, Keys.ATLAS_SHOP_UI, selected ? Keys.UI_SHOP_TAB_ACTIVE : Keys.UI_SHOP_TAB_INACTIVE);
        SpriteUtils.setDispSize(this.tabImage, 112 * CU.S, 50 * CU.S);
    }

}
